import React, {useState} from "react"
import {useSelector} from "react-redux"
import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DoYouWantInspectionReminder from "../InspectionReminder/DoYouWantInspectionReminder";
import InspectionReminder from "../InspectionReminder/InspectionReminder";
import {DateTime} from "luxon";
import {getLocale, numberToCurrencyString} from "../../../Utils/helpers";
import {ServiceCardType} from "../Types";
import {SelfServiceSettingsType} from '../../../interfaces'
import {RootState} from '../../../Redux'
import ReturnToStartScreenTimer from "../Common/ReturnToStartScreenTimer";

interface ReservationPaymentDoneProps {
    serviceCard: ServiceCardType
}

const ReservationPaymentDone = ({serviceCard}: ReservationPaymentDoneProps) => {
    const locale = getLocale();
    const { t } = useTranslation();

    const [inspectionReminder, setInspectionReminder] = useState<boolean>()
    const settings: SelfServiceSettingsType = useSelector((state: RootState) => state.ui.settings?.selfService ?? {});

    const registrationNumber = serviceCard.sale.tasks[0].vehicle.registrationNumber
    const serviceType = serviceCard.sale.tasks[0].basket.items[0].name
    const servicePrice = serviceCard.sale.totalPrice?.vatIncluded
    const date = DateTime.fromISO(
        serviceCard.sale.tasks[0].event.duration.start,
        {setZone: true}
    ).setLocale(locale);

    const onReminderBack = () => {
        setInspectionReminder(undefined)
    }

    if (inspectionReminder !== undefined) {
        return (
            <InspectionReminder
                orderReminder={inspectionReminder}
                serviceCard={serviceCard}
                onBack={onReminderBack}
            />
        )
    }

    return (<>
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className="pageMainContainer">
            <Grid className="pageMainHeader">
                <Typography variant="h4">{t('selfService.paymentSucceeded')}</Typography>
            </Grid>
            <Grid size="grow" container direction="column" justifyContent="center" alignItems="center">
                <div style={{textAlign: 'center'}}>
                    <Typography variant="h1" className="registrationNumber">{registrationNumber}</Typography>
                    <Typography variant="subtitle1" gutterBottom>{serviceType} {servicePrice ? numberToCurrencyString(servicePrice, 'EUR', 0) : null}</Typography>
                </div>
                <div style={{textAlign: 'center'}}>
                    <Typography variant="subtitle1">{t('selfService.youHaveReservation')}</Typography>
                    <Typography variant="subtitle1" className="reservationPaymentDoneDate">
                        {date.toFormat(`cccc dd.MM.yyyy '${t('common.time_of_day')}' HH:mm`)}
                    </Typography>
                </div>
            </Grid>
            <ReturnToStartScreenTimer time={60} showCloseButton={false}/>
            {settings.inspectionReminderAvailable ? <DoYouWantInspectionReminder onSelect={setInspectionReminder}/> : null}
        </Grid>
    </>)
}

export default ReservationPaymentDone
